import useCollapse from "../../../hooks/collapse-item.hook";

function Toggle({ children }) {
	const { isOpen, handleToggle, isClosed } = useCollapse();

	return (
		// biome-ignore lint/a11y/useSemanticElements: the toggle wraps caller-provided content that may contain interactive controls.
		<div
			onClick={handleToggle}
			onKeyDown={(event) => {
				if (event.key === "Enter" || event.key === " ") {
					event.preventDefault();
					handleToggle();
				}
			}}
			role="button"
			tabIndex={0}
		>
			{typeof children === "function" ? children({ isOpen, isClosed }) : children}
		</div>
	);
}

export default Toggle;
